import { ref } from 'vue';
import type { Ref } from 'vue';

import type { OnOutsideClickHandler } from '@shared/types';

export function useErrorDropdown() {
  const errorDropdown = ref();
  const isErrorDropdownVisible = ref(false);

  function showErrorDropdown() {
    isErrorDropdownVisible.value = true;
  }

  function hideErrorDropdown() {
    isErrorDropdownVisible.value = false;
  }

  function createOnClickOutsideErrorDropdownHandler(
    ignore: Ref<HTMLElement | null> | Array<Ref<HTMLElement | null>>,
  ): OnOutsideClickHandler {
    const ignoreRefs = Array.isArray(ignore) ? ignore : [ignore];
    return [
      () => {
        hideErrorDropdown();
      },
      { ignore: ignoreRefs },
    ];
  }

  return {
    errorDropdown,
    isErrorDropdownVisible,
    showErrorDropdown,
    hideErrorDropdown,
    createOnClickOutsideErrorDropdownHandler,
  };
}
